import { render, staticRenderFns } from "./yatlxc.vue?vue&type=template&id=060564a8&scoped=true"
import script from "./yatlxc.vue?vue&type=script&lang=js"
export * from "./yatlxc.vue?vue&type=script&lang=js"
import style0 from "./yatlxc.vue?vue&type=style&index=0&id=060564a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060564a8",
  null
  
)

export default component.exports